import { Box } from '@mui/material';
import React, { useState } from 'react';
import CommunicationHeader from './CommunicationHeader';
import { CommunicationItemProps } from '../types/types';
import { communicationItemStyles } from '../styles/styles';
import { Primary } from '../../../core-components/theme/color-palette/colors';
import AttachmentPreviewDialog from '../../../core-components/theme/components/DialogBox/AttachmentPreviewDialog';
import EmailPreviewDialog from '../../CommunicationModule/components/EmailPreviewDialog';
import WhatsappSmsPreviewDialog from '../../CommunicationModule/components/WhatsappSmsPreviewDialog';
import { trackEvent } from '../../../modules/analytics/trackingMiddleware';
import { COMMUNICATION_OPENED } from '../../../modules/analytics/events';

const CommunicationItem: React.FC<CommunicationItemProps> = ({ communication, handleStatus, onClick }) => {
  const [attachmentDialogOpen, setAttachmentDialogOpen] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState<any>(null);

  const handleAttachmentClick = (attachment: any, event?: React.MouseEvent) => {
    if (event) {
      event.stopPropagation();
    }
    setSelectedAttachment(attachment);
    setAttachmentDialogOpen(true);
  };
    const [whatsAppSmsDialogOpen, setWhatsAppSmsDialogOpen] = useState(false);

  const handleDialogClose = () => {
    setWhatsAppSmsDialogOpen(false);
    setAttachmentDialogOpen(false);
    setSelectedAttachment(null);
    setEmailDialogOpen(false);
  };

  const [emailDialogOpen, setEmailDialogOpen] = useState(false);

  const handleItemClick = (event: React.MouseEvent) => {
    if (event.defaultPrevented) return;
    trackEvent(COMMUNICATION_OPENED, { communicationId: communication.communicationId, channel: communication.channel });
    if (communication.channel === 'EMAIL') {
      setEmailDialogOpen(true);
    } else if (communication.channel === 'WHATSAPP' || communication.channel === 'SMS') {
      setWhatsAppSmsDialogOpen(true);
    } else {
      onClick?.(communication.communicationId, communication.multipleConversationExists);
    }
  };
  return (
    <>
      <Box
        sx={{
          ...(communicationItemStyles as object),
          backgroundColor: communication?.communicationStatus === 'UNREAD' ? Primary[100] : undefined,
          cursor: onClick ? 'pointer' : 'default',
        }}
        onClick={handleItemClick}
      >
        <CommunicationHeader
          handleStatus={handleStatus}
          communication={communication}
          onAttachmentClick={handleAttachmentClick}
        />
      </Box>
      {attachmentDialogOpen && (
      <AttachmentPreviewDialog
        open={attachmentDialogOpen}
        onClose={handleDialogClose}
        attachment={selectedAttachment}
      />
      )}

      {emailDialogOpen && (
        <EmailPreviewDialog
         open={emailDialogOpen}
         onClose={handleDialogClose} 
         communication={communication}
        />
      )}

      {whatsAppSmsDialogOpen && (
        <WhatsappSmsPreviewDialog
         open={whatsAppSmsDialogOpen} 
         onClose={handleDialogClose} 
         communication={communication} 
        />
      )}
    </>
  );
};

export default CommunicationItem; 